import jwt from "jsonwebtoken";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

const product = {
  state: {
    listProduct: [],
    position: 0,
    total: 0,
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getProduct(payload = {}, rootState) {
      let url =
        DomainAPI +
        Channel +
        `/api/secure/products/getProducts?category_id=${payload.category_id || ""
        }&&sort=date_created&&limit=${payload.limit || 10}&&offset=${payload.limit * payload.page || 0
        }&&search=${payload.search || ""}`;
      if (payload.enabled) url += `&&enabled=${payload.enabled}`;
      if (payload.on_sale) url += `&&on_sale=${payload.on_sale}`;
      if (payload.stock_status) url += `&&stock_status=${payload.stock_status}`;
      if (payload.discontinued) url += `&&discontinued=${payload.discontinued}`;
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        // body: JSON.stringify(payload)
      })
        .then((res) => res.json())
        .then((result) => {
          if (result && Array.isArray(result.data)) {
            this.setState({
              listProduct: result.data,
              total: result.total_count,
            });
            //checkResponse(result, dispatch)
            return result;
          }
          return {};
        })
        .catch((error) => {
          console.log(error);
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getProductsByIdArray(payload = {}, rootState) {
      let url = DomainAPI + Channel + `/api/secure/getProductsByIdArray`;
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "post",
        headers: myHeaders,
        body: JSON.stringify({ idArray: payload.idArray || [] }),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          console.log(error);
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async getSingleProduct(payload = {}, rootState) {
      let url = DomainAPI + Channel + `/api/secure/products/getSingleProduct`;
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ id: payload }),
      })
        .then((res) => res.json())
        .then((result) => {
          //checkResponse(result, dispatch)
          return result;
        })
        .catch((error) => {
          console.log(error);
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async insertProduct(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/products/addProduct";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          //checkResponse(result, dispatch)
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async updateProduct(payload, rootState) {
      let url = DomainAPI + Channel + "/api/secure/products/update/";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((result) => {
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async deleteProduct(payload = {}, rootState) {
      let url = DomainAPI + Channel + "/api/secure/products/deleteProduct";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({ id: payload }),
      })
        .then((res) => res.json())
        .then((result) => {
          //checkResponse(result, dispatch)
          return result;
        })
        .catch((error) => {
          console.log(error);
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default product;
